export default "__VITE_ASSET__rjN0XQ3GPIBCaKLnrJLFMw__";